<template>
  <div class="areaDialog">
    <md-dialog
      md-open-from="#addArea"
      md-close-to="#addArea"
      ref="add_area_dialog"
    >
      <md-dialog-title>Informações da Área</md-dialog-title>
      <md-dialog-content>
        <md-input-container>
          <label>Nome da Area</label>
          <md-select v-model="area.name">
            <!-- <md-subheader>Pontos</md-subheader>
            <md-option value="hydraulic">Hidráulico com nome grande pra caramba que pode até quebrar a pagina</md-option>
            <md-option value="eletric">Elétrico</md-option>
            <md-subheader>Equipamentos</md-subheader> -->
            <md-option
              v-for="(area, index) in areaList"
              :value="area.name"
              :key="index"
              >{{ area.name }}</md-option
            >
          </md-select>
          <!-- <md-input v-model="area.name" required></md-input> -->
        </md-input-container>
        <md-input-container>
          <label>Informações adicionais</label>
          <md-input v-model="area.description"></md-input>
        </md-input-container>
        <md-input-container>
          <label for="conformidade">Acordo com exigência legal</label>
          <md-select
            name="conformidade"
            id="conformidade"
            required
            multiple
            v-model="area.conformidade"
          >
            <md-option
              v-for="(option, index) in itensRDC50"
              :key="index"
              :value="option.id"
            >
              {{ option.name }}
            </md-option>
          </md-select>
        </md-input-container>
        <md-input-container>
          <label>Tipo de revestimento do piso</label>
          <md-input v-model.trim="area.tipoPiso"></md-input>
        </md-input-container>
        <md-input-container>
          <label>Tipo de revestimento do teto</label>
          <md-input v-model.trim="area.tipoTeto"></md-input>
        </md-input-container>
        <md-input-container>
          <label>Tipo de revestimento da parede</label>
          <md-input v-model.trim="area.tipoParede"></md-input>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="close()">Cancelar</md-button>
        <md-button
          class="md-primary"
          v-show="this.areakey"
          @click="removeArea()"
          >Excluir</md-button
        >
        <md-button class="md-primary" v-show="this.areakey" @click="saveArea()"
          >Alterar</md-button
        >
        <md-button class="md-primary" v-show="!this.areakey" @click="addArea()"
          >Adicionar</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'addAreaDialog',
  computed: {
    ...mapState({
      areaList: state => state.areasList
    })
  },
  data: () => ({
    area: {
      name: '',
      // description: '',
      x: 0,
      y: 0,
      w: 100,
      h: 100,
      conformidade: [],
      tipoPiso: '',
      tipoTeto: '',
      tipoParede: ''
    },
    areakey: null,
    itensRDC50: [
      { id: 1, name: 'Piso' },
      { id: 2, name: 'Teto' },
      { id: 3, name: 'Parede' },
      { id: 4, name: 'Rodapé' },
      { id: 5, name: 'Luminária' },
      { id: 6, name: 'Janela' },
      { id: 7, name: 'Portas' },
      { id: 8, name: 'Ralo' },
      { id: 9, name: 'Climatização' },
      { id: 10, name: 'Conservação do Ambiente' }
    ]
  }),
  beforeMount() {
    this.FETCH_AREAS()
  },
  methods: {
    ...mapActions(['CREATE_AREA', 'SET_AREA', 'REMOVE_AREA', 'FETCH_AREAS']),
    open() {
      this.reset()
      this.$refs.add_area_dialog.open()
    },
    edit(_area, _areakey) {
      this.area = _area
      this.areakey = _areakey
      this.$refs.add_area_dialog.open()
    },
    close() {
      this.$refs.add_area_dialog.close()
    },
    reset() {
      this.areakey = null
      this.area = {
        name: '',
        // description: '',
        x: 0,
        y: 0,
        w: 100,
        h: 100,
        conformidade: [],
        // vertices: [],
        tipoParede: '',
        tipoPiso: '',
        tipoTeto: ''
      }
    },
    removeArea() {
      this.$refs.add_area_dialog.close()
      this.REMOVE_AREA(this.areakey)
    },
    saveArea() {
      this.$refs.add_area_dialog.close()
      this.SET_AREA({ area: this.area, key: this.areakey })
    },
    addArea() {
      this.$refs.add_area_dialog.close()
      this.CREATE_AREA(this.area)
    }
  }
}
</script>
<style scoped>
.md-input-container {
  margin: 4px 0 13px;
}
</style>



// WEBPACK FOOTER //
// AddAreaDialog.vue?42e73468